module.exports = __webpack_public_path__ + "img/content8.bdfdb959.png";